import SoftwareVersionService from 'actions/version/software_version_service';

export default class UpgradeSoftware {
  run() {
    SoftwareVersionService.upgrade();
  }
}
